import { render, staticRenderFns } from "./citySelector.vue?vue&type=template&id=610c9006&scoped=true"
import script from "./citySelector.vue?vue&type=script&lang=js"
export * from "./citySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c9006",
  null
  
)

export default component.exports